import type { RestaurantMenu } from '../api/types'
import type { CartLine } from './types'

export function findUnavailableLines(
  lines: CartLine[],
  menu: RestaurantMenu | undefined,
): CartLine[] {
  if (!menu) return []

  const itemsById = new Map(menu.categories.flatMap((c) => c.items).map((item) => [item.id, item]))

  return lines.filter((line) => {
    const item = itemsById.get(line.menuItemId)
    return !item || item.is_available === false
  })
}

export function describeUnavailable(lines: CartLine[]): string {
  const names = lines.map((line) => line.name).join(', ')
  const isPlural = lines.length > 1
  return `${names} ${isPlural ? 'are' : 'is'} no longer available and ${isPlural ? 'have' : 'has'} been removed from your order.`
}
